import React, { useContext } from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LazyContext from '../LazyLoadingImage/LazyContext';
import SidebarBlock from './SidebarBlock';
import LoaderBlock from './_partials/LoaderBlock';
import { getRelatedContentReady } from '../DeviationPage/redux/selectors';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import SidebarInviewSentinal from './_partials/SidebarInviewSentinal/SidebarInviewSentinal';
import s from './Sidebar.scss';
/**
 * Returns `true` if the supplied {@link block} is one we've provided an alternative placement for on mobile
 */ export function shouldRelocateBlockOnMobile(block) {
    // Monetization promos that aren't the dreamup one have a higher placement on mobile
    if (block.contentType.startsWith('monetization_promotion') && block.contentType !== 'monetization_promotion_dreamup_thirdparty') {
        return true;
    }
    // adoptable_info and pcp_info have a higher placement on mobile
    if ([
        'adoptable_info',
        'pcp_info'
    ].includes(block.contentType)) {
        return true;
    }
    return false;
}
function shouldRenderSidebarBlock(block, isDesktop) {
    return isDesktop ? true : !shouldRelocateBlockOnMobile(block);
}
const Sidebar = ({ deviation, className })=>{
    var _deviation_extended;
    const relatedLoaded = useSelector((state)=>getRelatedContentReady(state, deviation));
    const isDesktop = !useContext(MobileContext);
    const blocks = deviation === null || deviation === void 0 ? void 0 : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.relatedContent;
    const isLoading = !deviation.extended;
    const relatedIsReady = !isLoading && relatedLoaded;
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "Sidebar"
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className),
        role: "complementary"
    }, isDesktop && /*#__PURE__*/ React.createElement(SidebarInviewSentinal, {
        key: deviation.deviationId,
        deviation: deviation,
        isDesktop: true
    }), relatedIsReady && blocks && blocks.map((block, index)=>shouldRenderSidebarBlock(block, isDesktop) && /*#__PURE__*/ React.createElement(LazyContext.Provider, {
            value: isDesktop ? index > 1 : true,
            key: block.contentType
        }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            value: {
                _rankOffset: 0
            }
        }, /*#__PURE__*/ React.createElement(SidebarBlock, {
            block: block,
            deviation: deviation
        })))), !relatedIsReady && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LoaderBlock, {
        index: 0
    }), /*#__PURE__*/ React.createElement(LoaderBlock, {
        index: 1
    }), /*#__PURE__*/ React.createElement(LoaderBlock, {
        index: 2
    }))));
};
Sidebar.displayName = 'Sidebar';
export default Sidebar;
